import { getAllOstanCity, getAllSchools } from "@/api/aboutus";
import {
  getSchoolInfo,
  getSchoolPersonnel,
  getSchoolPictures,
  getSchoolTeachers,
} from "../../api/aboutus";
export default {
  state: {
    ostanCities: [],
    schoolInfo: {},
    schoolTeachers: [],
    schoolPersonnel: [],
    schoolPictures: [],
  },

  mutations: {
    SET_OSTANCITIES: (state, data) => {
      state.ostanCities = [...data];
    },
    SET_SCHOOLINFORMATION: (state, data) => {
      state.schoolInfo = data;
    },
    SET_SCHOOLPERSONNEL: (state, data) => {
      state.schoolPersonnel = [...data];
    },
    SET_SCHOOLTEACHERS: (state, data) => {
      state.schoolTeachers = [...data];
    },
    SET_SCHOOLPICTURES: (state, data) => {
      state.schoolPictures = [...data];
    },
  },

  actions: {
    getAllOstanCity({ commit }) {
      commit("SET_TABLE_TEXT", true);
      commit("SET_PROGRESS_SHOW", true);
      return new Promise((resolve, reject) => {
        getAllOstanCity()
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            var data = response.data;

            commit("SET_OSTANCITIES", data);
            commit("SET_TABLE_TEXT", false);
            commit("SET_PROGRESS_SHOW", false);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getSchoolInfo({ commit }, payload) {
      commit("SET_TABLE_TEXT", true);
      commit("SET_PROGRESS_SHOW", true);
      return new Promise((resolve, reject) => {
        getSchoolInfo(payload)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            var data = response.data;

            data.jensiatString =
              data.jensiatSerial === "1" ? "برادران" : "خواهران";
            data.sath =
              `سطوح  ${data.isSath1 === "True" ? " 1" : ""}` +
              `${data.isSath2 === "True" ? " 2" : ""}` +
              `${data.isSath3 === "True" ? " 3" : ""}`;
            data.socialNetworks =
              ` ${
                data.socialNetwork1 !== "" ? "\n 1: " + data.socialNetwork1 : ""
              }` +
              ` ${
                data.socialNetwork2 !== "" ? "\n 2: " + data.socialNetwork2 : ""
              }` +
              ` ${
                data.socialNetwork3 !== "" ? "\n 3: " + data.socialNetwork3 : ""
              }` +
              ` ${
                data.socialNetwork4 !== "" ? "\n 4: " + data.socialNetwork4 : ""
              }`;

            commit("SET_SCHOOLINFORMATION", data);
            commit("SET_TABLE_TEXT", false);
            commit("SET_PROGRESS_SHOW", false);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getSchoolPersonnel({ commit }, payload) {
      commit("SET_TABLE_TEXT", true);
      commit("SET_PROGRESS_SHOW", true);
      return new Promise((resolve, reject) => {
        getSchoolPersonnel(payload)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            var data = response.data;
            data = data.filter((item) => item.isValid == "1");

            commit("SET_SCHOOLPERSONNEL", data);
            commit("SET_TABLE_TEXT", false);
            commit("SET_PROGRESS_SHOW", false);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getSchoolTeachers({ commit }, payload) {
      commit("SET_TABLE_TEXT", true);
      commit("SET_PROGRESS_SHOW", true);
      return new Promise((resolve, reject) => {
        getSchoolTeachers(payload)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            var data = response.data;
            data = data.filter((item) => item.isValid == "1");

            commit("SET_SCHOOLTEACHERS", data);
            commit("SET_TABLE_TEXT", false);
            commit("SET_PROGRESS_SHOW", false);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getSchoolPictures({ commit }, payload) {
      commit("SET_TABLE_TEXT", true);
      commit("SET_PROGRESS_SHOW", true);
      return new Promise((resolve, reject) => {
        getSchoolPictures(payload)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            var data = response.data;
            data = data.map((item) => {
              return {
                ...item,
                largeData: (item.largeData = `data:image/jpg;base64,${item.largeData}`),
                smallData: (item.smallData = `data:image/jpg;base64,${item.smallData}`),
              };
            });

            commit("SET_SCHOOLPICTURES", data);
            commit("SET_TABLE_TEXT", false);
            commit("SET_PROGRESS_SHOW", false);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },

  getters: {
    schoolInformation() {
      return schoolInfo;
    },
  },
};
